import { render, staticRenderFns } from "./index copy 2.vue?vue&type=template&id=371c10a0"
import script from "./index copy 2.vue?vue&type=script&lang=js"
export * from "./index copy 2.vue?vue&type=script&lang=js"
import style0 from "./index copy 2.vue?vue&type=style&index=0&id=371c10a0&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports